"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// implementation placeholder
exports.createMultipleComponentSimulations = (componentSimulations) => componentSimulations;
// implementation placeholder
exports.createComponentSimulation = (componentSimulation) => componentSimulation;
//# sourceMappingURL=create-simulation.js.map